import { useCallback } from 'react';
import type { MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import styles from './ReportFooter.module.css';

interface PreviewReportLinkProps {
  href: string;
  disabled?: boolean;
}

/**
 * "Preview Report" link. Uses a router `<Link>` rather than a bare anchor —
 * a plain `href` here triggers a full document load, which re-boots the whole
 * SPA and throws away the Redux cache on the way to the preview page.
 * It never saves: only Save saves.
 */
export function PreviewReportLink({
  href,
  disabled = false,
}: PreviewReportLinkProps) {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      if (disabled) e.preventDefault();
    },
    [disabled]
  );

  return (
    <Link
      to={href}
      className={`${styles.linkButton} ${disabled ? styles.linkButtonDisabled : ''}`}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : undefined}
      onClick={handleClick}
    >
      Preview Report
    </Link>
  );
}
